import type { Translation } from '../types.ts';
import type en from '../en/seo.ts';

export default {
    card: {
        title: 'SEO',
        sharedNote: 'Robots, canonical en de Open Graph-afbeelding gelden voor alle talen en bewerk je op het tabblad {locale}.',
    },
    fields: {
        metaDescription: 'Metabeschrijving',
        robots: 'Robots',
        canonical: 'Canonical overschrijven',
        ogImage: 'Open Graph-afbeelding',
        jsonLd: 'JSON-LD',
    },
    hints: {
        length: 'Optimale lengte is {min} tot {max} tekens',
    },
    jsonLd: {
        custom: 'Eigen versie',
        auto: 'Automatisch gegenereerd',
        reset: 'Terug naar automatisch',
        overrideHint: 'Bewerk om te overschrijven. Sla je een ongewijzigde automatische waarde op, dan blijft het automatisch, zodat toekomstige verbeteringen nog doorkomen.',
        translationHint: 'Laat leeg om het {locale}-document te gebruiken met de URL en titel van deze taal.',
    },
} satisfies Translation<typeof en>;
